import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import CustomField from '@/App/CustomField/Entity/CustomField'
import CustomFieldResponse from '@/App/CustomField/Entity/CustomFieldResponse'
import type { CustomFieldResponseDataData } from '@/Shared/AutoGenerated/Main'

export default class CustomFieldResponseData {
    constructor(
        public readonly customField: CustomField,
        public readonly response: CustomFieldResponse,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(
        entityData: CustomFieldResponseDataData,
    ): CustomFieldResponseData {
        return new CustomFieldResponseData(
            CustomField.hydrateSingle(entityData.customField),
            CustomFieldResponse.hydrateSingle(entityData.response),
        )
    }

    static hydrateMultiple(
        entitiesData: CustomFieldResponseDataData[],
    ): CustomFieldResponseData[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
